import { jsx as _jsx } from "react/jsx-runtime";
import { BaseEdge, getSmoothStepPath } from '@xyflow/react';
import { HIGHLIGHT_HEX, RECYCLE_HEX } from '../../../constants';
/**
 * Component renders "recycle" type of connection of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_EDGE_TYPES.
 */
const RFRecycleEdgeFC = ({ sourceX, sourceY, targetX, targetY, selected, markerEnd, sourcePosition, targetPosition, style = {} }) => {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        borderRadius: 8
    });
    return (_jsx(BaseEdge, { path: edgePath, markerEnd: markerEnd, style: { ...style, stroke: selected ? HIGHLIGHT_HEX : RECYCLE_HEX, strokeWidth: 1 } }));
};
export const RFRecycleEdge = RFRecycleEdgeFC;
//# sourceMappingURL=RFRecycleEdge.js.map